<template>
  <nav :aria-label="t('aria.breadcrumbs')" class="py-3 text-sm">
    <ol class="flex flex-wrap items-center gap-1.5 text-ink-muted">
      <li v-for="(item, index) in items" :key="index" class="inline-flex items-center gap-1.5">
        <BaseIcon
          v-if="index > 0"
          name="chevron-right"
          :size="16"
          class="shrink-0 text-ink-subtle"
        />
        <RouterLink
          v-if="item.to && index < items.length - 1"
          :to="item.to"
          class="text-ink-muted hover:text-accent-strong underline-offset-4 hover:underline"
        >
          {{ item.label }}
        </RouterLink>
        <span
          v-else
          :aria-current="index === items.length - 1 ? 'page' : undefined"
          :class="index === items.length - 1 ? 'font-medium text-ink-strong' : 'text-ink-muted'"
        >
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import BaseIcon from '@/components/base/BaseIcon.vue';
import type { BreadcrumbItem } from '@/types/component-types';

export type { BreadcrumbItem } from '@/types/component-types';

interface Props {
  items: readonly BreadcrumbItem[];
}

defineProps<Props>();

const { t } = useI18n();
</script>
